var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "atlas" } }, [
    _c("section", { staticClass: "menu_ctrl" }, [
      _c("span", { staticClass: "text" }, [_vm._v("選擇資料")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "icon-container" },
        [
          _c("QpeTooltip", {
            scopedSlots: _vm._u([
              {
                key: "hovered_item",
                fn: function() {
                  return [
                    _c(
                      "v-icon",
                      {
                        attrs: { color: "white" },
                        on: { click: _vm.close_all }
                      },
                      [
                        _vm._v(
                          "\n                        icon-unfold-less\n                    "
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              },
              {
                key: "tooltip_content",
                fn: function() {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("__map_obs.close_all_tree")))
                    ])
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "atlas_treeview" },
      [
        _vm.init_items.length > 0
          ? _c("TreeView", {
              ref: "child_treeview",
              attrs: {
                current_tab: "atlas",
                init_items: _vm.init_items,
                checked_selectors: _vm.checked_selectors,
                init_opened_layers: [],
                check_function: _vm.change_atlas_type
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }